export default __webpack_public_path__ + "static/media/37_mobile.4c9819d6.jpg";